import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetindirectmaterialpage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetIndirectMaterialPage } = await import(
        /* webpackChunkName: "BudgetIndirectMaterial" */ '../../../components/pages/private/BudgetIndirectMaterialPage'
      )
      return {
        default: BudgetIndirectMaterialPage,
      }
    })}
    exact
    key={paths.indirectMaterialImport}
    path={paths.indirectMaterialImport}
  />,
]
